// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__oE8oo","notes":"Notes_notes__IEq2s"};